module.exports = __webpack_public_path__ + "static/media/2030.63851a75.svg";